import React, { useContext, useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';

import { ERROR_MESSAGE } from '../../components/Messages/Messages';
import ProductPageContext from '../../contexts/ProductPageContext';
import buildQueryString from '../../tools/buildQueryString';

export const getUrlWithQueryParams = (elevatedFit, defaultSwatchSequence) => {
  if (!elevatedFit) return '';

  return `${elevatedFit?.fitOppositeUrl}?${buildQueryString({
    seq: defaultSwatchSequence,
    pagefm: elevatedFit?.analyticsParam,
  })}`;
};

const elevatedFitData = gql`
query elevatedFit(
  $collectionId: String!,
) {
  elevatedFit: elevatedFit(collectionId: $collectionId) {
    fitText
    fitDescription
    fitType
    alsoInText
    fitOpposite
    fitOppositeUrl
    analyticsParam
  }
}
`;

export default function ElevatedFit() {
  const ProductPageState = useContext(ProductPageContext);
  const {
    error, data, previousData,
  } = useQuery(elevatedFitData, {
    variables: {
      collectionId: `${ProductPageState?.collectionId}`,
    },
    context: { batch: true },
  });

  const { defaultSwatchSequence } = ProductPageState.collectionData.activeProduct;
  const queryData = data || previousData;
  const { elevatedFit } = queryData || {};

  const urlWithQueryParams = useMemo(() => getUrlWithQueryParams(
    elevatedFit,
    defaultSwatchSequence,
  ), [elevatedFit, defaultSwatchSequence]);

  if (error) {
    return ERROR_MESSAGE;
  }

  if (!elevatedFit) return null;

  return (
    <div className="elevated-fit-container" data-testid="elevated-fit">
      <span className="current-fit">
        <span className="fit">
          {elevatedFit?.fitText}
          :
        </span>
        {' '}
        {elevatedFit?.fitType}
      </span>

      <p className="description">
        {elevatedFit?.fitDescription}
      </p>

      <span className="opposite">
        {elevatedFit?.alsoInText}
        {' '}
        <a href={urlWithQueryParams} className="opposite-url">{elevatedFit?.fitOpposite}</a>
        .
      </span>
    </div>
  );
}
